import { api } from "@/api"
import type { ProductTagColor } from "./productTagColors"
import { useQuery } from "@tanstack/vue-query"

export type ListProductTagsResponseItem = DeepReadonly<{
  id: string
  label: string
  color: ProductTagColor
  isHidden: boolean
}>

const listProductTags = async (): Promise<
  ListProductTagsResponseItem[]
> => {
  const response = await api.get<
    ListProductTagsResponseItem[]
  >("/products/product-tags/")
  return response.body
}

export const useProductTags = () => {
  const { data, isFetching } = useQuery({
    queryKey: [PRODUCT_TAG_QUERY_KEY],
    queryFn: () => listProductTags(),
    staleTime: 60 * 60 * 1000,
  })

  const getById = (productTagId: string) =>
    computed(() =>
      data.value?.find(
        (productTag) => productTag.id === productTagId
      )
    )
  return {
    data,
    isFetching,
    getById,
    asOptions: computed(
      () =>
        data.value?.map(({ label, id }) => ({
          value: id,
          label: label,
        })) || []
    ),
  }
}

export const useProductTag = (
  productTagId: string | Ref<string>
) => {
  const { data: allProductTags, isFetching } =
    useProductTags()
  const data = computed(() =>
    allProductTags.value?.find(
      (productTag) => productTag.id === productTagId
    )
  )

  return {
    data,
    isFetching,
  }
}
